const Jira = {
  projects: {
    AD: {
      name: "Ad Builder",
      productOwner: "Jakub Kierszka"
    },
    // CRM: {
    //   name: "Automatic",
    //   productOwner: ""
    // },
    CON: {
      name: "Conversations",
      productOwner: "Brittany Sabatino"
    },
    FUEL: {
      name: "Fuel",
      productOwner: "Jakub Kierszka"
    },
    INT: {
      name: "Internal APIs",
      productOwner: "Matt Sullivan"
    },
    MS: {
      name: "Managed Services",
      productOwner: "Michael Murphey"
    },
    MT: {
      name: "Market Takeover",
      productOwner: "Mike Murphey"
    },
    ONSHOP: {
      name: "Online Shopper",
      productOwner: "Nate Jones (Temp)"
    },
    PRIZ: {
      name: "Prizm",
      productOwner: "Brie Whitfield"
    },
    WEB: {
      name: "Website Features",
      productOwner: "Stephanie Kuczynski"
    }
  }
};

export default Jira;
